var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCtaOutline = function SvgPlayCtaOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.861 10.598-.354.62L4.585 2.134a1.111 1.111 0 0 0-1.088-.001 1.048 1.048 0 0 0-.536.906v17.924c0 .367.203.715.53.903a1.106 1.106 0 0 0 1.083.008l15.921-8.839a1.05 1.05 0 0 0 .544-.905 1.047 1.047 0 0 0-.532-.91l.354-.621Zm1.608 1.54a2.479 2.479 0 0 1-1.28 2.146l-15.92 8.839a2.536 2.536 0 0 1-2.488-.018 2.479 2.479 0 0 1-1.25-2.143V3.038c0-.888.485-1.71 1.262-2.151a2.541 2.541 0 0 1 2.502.004l15.921 9.086a2.477 2.477 0 0 1 1.254 2.16Z",
    fill: "currentColor"
  })));
};
export default SvgPlayCtaOutline;